<div class="form-group position-relative">
    <input [type]="type" class="form-control" [placeholder]="placeholder" [(ngModel)]="initialValue"
        (ngModelChange)="emitOutput()" [ngClass]="{'is-valid': isValid, 'is-invalid': isValid === false}">
</div>